module.exports = __webpack_public_path__ + "img/XOF.966c1f1d.svg";